/**
 * This is wrapper adds animation to any component you wrap it with. This file using the animations.css
 * Feel free to add animations to animations.css as you need them
 * You can preview animations here: https://covalent.netlify.app/
 *
 * <hh-animate-on-scroll
      data-target=<target>
      data-animation-class=<animation class>
    >
    </hh-animate-on-scroll>
 *
 * @param {string} target The target element you want to animate
 * @param {string} animationClass The animation you want to apply to the target (See options in animations.css)
 * @param {number} [animationThreshold=0.25] The amount of the target element that will be visible when the animation is triggered
*/

import { utils } from '@hh/global.js'

const { prefersReducedMotion } = utils
class HHAnimateOnScroll extends HTMLElement {
  constructor() {
    super()
    this.observer = null
  }

  connectedCallback() {
    this.target = this.dataset.target || 'adaptive-image'
    this.animationClass = this.dataset.animationClass || 'zoomin'
    this.animationThreshold = this.dataset.animationThreshold || 0.1
    // This sets the inital state before the animation occurs
    this.classList.add(this.animationClass)

    const mediaQuery = prefersReducedMotion()
    if (mediaQuery.matches) return
    const intersectionOptions = {
      root: null,
      threshold: this.animationThreshold,
    }
    this.observer = new IntersectionObserver((entries) => {
      // Loop over the entries
      entries.forEach((entry) => {
        // If the element is visible
        if (entry.isIntersecting) {
          // Add the animation class
          // This line removes the intial state class
          entry.target.classList.remove(this.animationClass)
          entry.target
            .querySelector(this.target)
            ?.classList.add(this.animationClass)
        }
      })
    }, intersectionOptions)

    // Tell the observer which elements to track
    this.observer?.observe(this)
  }

  disconnectedCallback() {
    this.observer?.unobserve(this)
  }
}

customElements.define('hh-animate-on-scroll', HHAnimateOnScroll)
